const IsKazaDurumEnum = {
    0: "Oluşturuldu",
    1: "Kullanıcıda",
    2: "Bildirim Okundu Kapatıldı",
    3: "Manuel Kapatıldı",
}

export default IsKazaDurumEnum;
